"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lotteryAssistant = require("@/api/lotteryAssistant");
var _permission = require("@/utils/permission");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var operateMaps = {
  add: '新增中奖名单',
  edit: '编辑中奖名单',
  detail: '中奖名单详情'
};
var _default = exports.default = {
  name: 'LotteryAssistantReplyCreate',
  data: function data() {
    return {
      operate: 'add',
      operateMaps: operateMaps,
      id: '',
      grid: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
      loading: false,
      detail: {},
      formValidate: {
        userName: '',
        userAvatar: '',
        replyMsg: '',
        replyPic: '',
        isEnabled: true
      },
      picList: [],
      ruleValidate: {
        userName: [{
          required: true,
          message: '请输入用户名称',
          trigger: 'blur'
        }],
        userAvatar: [{
          required: true,
          message: '请上传用户头像',
          trigger: 'change'
        }]
      },
      loadingBtn: false
    };
  },
  computed: {
    isDisabled: function isDisabled() {
      return this.operate === 'detail';
    },
    isEdit: function isEdit() {
      return this.operate === 'edit';
    }
  },
  created: function created() {
    this.operate = this.$route.query.operate || 'add';
    this.id = this.$route.query.id;
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (this.id) {
              this.getDetail(this.id);
            }
          case 1:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    checkPermi: _permission.checkPermi,
    getDetail: function getDetail(id) {
      var _this2 = this;
      this.loading = true;
      (0, _lotteryAssistant.drawReplyDetailApi)(id).then(function (data) {
        _this2.initData(data);
        _this2.loading = false;
      }).catch(function (res) {
        _this2.loading = false;
      });
    },
    initData: function initData(data) {
      this.detail = data;
      for (var key in data) {
        if (this.formValidate.hasOwnProperty(key)) {
          this.formValidate[key] = data[key];
        }
      }
      if (data.replyPic) {
        this.picList = data.replyPic.split(',');
      }
    },
    modalPicTap: function modalPicTap(type) {
      var _this = this;
      if (_this.isDisabled) return;
      this.$modalUpload(function (img) {
        if (!img) return;
        if (type === 'avatar') {
          _this.formValidate.userAvatar = img[0].sattDir;
        } else {
          if (_this.picList.length >= 10) {
            _this.$message.warning('最多只能上传10张图片');
            return;
          }
          _this.picList.push(img[0].sattDir);
          _this.formValidate.replyPic = _this.picList.join(',');
        }
      }, false, 'content');
    },
    handleRemovePic: function handleRemovePic(index) {
      this.picList.splice(index, 1);
      this.formValidate.replyPic = this.picList.join(',');
    },
    //保存接口数据更新
    getFormData: function getFormData() {
      var data = _objectSpread({}, this.formValidate);
      if (this.operate === 'edit') {
        data.id = this.id;
      }
      return data;
    },
    // 保存
    handleSubmit: function handleSubmit(name) {
      var _this3 = this;
      this.$refs[name].validate(function (valid, obj) {
        if (valid) {
          _this3.postData();
        } else {
          for (var key in obj) {
            var msg = obj[key][0].message;
            return _this3.$message.warning(msg);
          }
        }
      });
    },
    // 新增保存数据
    postData: function postData() {
      var _this4 = this;
      this.loadingBtn = true;
      var data = this.getFormData();
      if (!data) {
        this.loadingBtn = false;
        return;
      }
      var func = this.operate === 'edit' ? _lotteryAssistant.drawReplyUpdateApi : _lotteryAssistant.drawReplyCreateApi;
      func(data).then(function () {
        _this4.$message.success('保存成功');
        setTimeout(function () {
          _this4.$router.push({
            path: '/marketing/lottery-assistant/reply'
          });
        }, 500);
        _this4.closeSelectedTag();
        _this4.loadingBtn = false;
      }).catch(function () {
        _this4.loadingBtn = false;
      });
    },
    isActive: function isActive(route) {
      return route.path === this.$route.path;
    },
    closeSelectedTag: function closeSelectedTag() {
      var _this5 = this;
      this.$store.dispatch('tagsView/delView', this.$route).then(function (_ref) {
        var visitedViews = _ref.visitedViews;
        if (_this5.isActive(_this5.$route)) {
          _this5.toLastView(visitedViews, _this5.$route);
        }
      });
    },
    toLastView: function toLastView(visitedViews, view) {
      var latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView.fullPath);
      } else {
        if (view.name === 'Dashboard') {
          this.$router.replace({
            path: '/redirect' + view.fullPath
          });
        } else {
          this.$router.push('/');
        }
      }
    }
  }
};